var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconWebWalletLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tick_empty",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .walletline {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "walletline",
    d: "M42.68,23.42c0-2.72-2.08-6.31-6.15-6.31H13.45c-3.4,0-6.15-1.25-6.15-4.99s2.8-4.99,6.24-4.99h21.95c3.4,0,6.15,2.25,6.15,4.92v1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "walletline",
    d: "M13.54,42.86h-.09c-3.4,0-6.15-2.75-6.15-6.15v-.09c0,3.45,2.8,6.24,6.24,6.24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "walletline",
    d: "M36.53,42.86h-.09c3.45,0,6.24-2.8,6.24-6.24v.09c0,3.4-2.75,6.15-6.15,6.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "walletline",
    d: "M36.44,42.86H13.54c-3.45,0-6.24-2.8-6.24-6.24V11.97c0,4.07,2.75,5.2,6.15,5.2h23.08c3.4,0,6.15,2.75,6.15,6.15v13.28c0,3.45-2.8,6.24-6.24,6.24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "walletline",
    d: "M33.14,24.96h7.63v7.63c0,2.11-1.71,3.82-3.82,3.82h0c-2.11,0-3.82-1.71-3.82-3.82v-7.63h0Z",
    transform: "translate(67.64 -6.28) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconWebWalletLine);
export default __webpack_public_path__ + "static/media/cloud_icon_web_wallet_line.5691e77c0d06fbc337449e0577aa5a59.svg";
export { ForwardRef as ReactComponent };